import React from 'react';
import { Breadcrumb as BootstrapBreadcrumb } from 'react-bootstrap';

const Breadcrumb = ({ 
    items = [], 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapBreadcrumb className={className} style={style} {...props}>
            {items.map((item, index) => (
                <BootstrapBreadcrumb.Item 
                    key={index}
                    active={item.active || index === items.length - 1}
                    href={item.href}
                    onClick={item.onClick}
                >
                    {item.label || item.text || item}
                </BootstrapBreadcrumb.Item>
            ))}
        </BootstrapBreadcrumb>
    );
};

export default Breadcrumb;

